import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <IndexSection />
        <AboutSection />
        <FaqSection />
        <CarouselSection />
        <ContactSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}